import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-success-dialog",
  templateUrl: "./success-dialog.component.html",
  styleUrls: ["./success-dialog.component.css"],
})
export class SuccessDialogComponent {
  constructor(public modalRef: BsModalRef) {}

  @Input() header = "Confirmation";
  @Input() body = "Are you sure you want to perform this action?";
  @Input() positiveButtonText = "Proceed";
  @Input() negativeButtonText = "Cancel";
  @Input() dismissOnConfirm = true;
  @Input() showCancel = true;
  @Input() showLoadingOnConfirmClick = true;
  @Output()
  onConfirmClicked = new EventEmitter();
  @Input() loading = false;
  onConfirm: any = () => {};

  close(reload?: boolean) {
    this.modalRef.hide();
    location.reload();
  }

  confirm() {
    if (this.showLoadingOnConfirmClick) {
      this.loading = true;
    }
    this.onConfirm();
    this.onConfirmClicked.emit();
    if (this.dismissOnConfirm) {
      this.modalRef.hide();
    }
  }
}
